export default "__VITE_ASSET__DpiOvUjA__"